import { parseBraceAttrs } from "@ext/markdown/logic/braceAttrs";

/**
 * The info string of a diagram fence: the language, then the markup in braces --
 * ```mermaid {title="Схема обмена" scale=476px}```. The language stays the first word, so GitHub
 * still recognises the block. Gramax used to write the title after a colon: that form is read but
 * not written -- GitHub takes `mermaid:Схема` for a language of its own and draws nothing.
 */
const parseDiagramInfo = (info?: string): { name: string; attrs: Record<string, string> } => {
	const text = info ?? "";
	const brace = text.indexOf("{");
	const head = (brace === -1 ? text : text.slice(0, brace)).trim();
	const attrs = { ...(brace === -1 ? null : parseBraceAttrs(text.slice(brace))) };

	const colon = head.indexOf(":");
	const isLegacy = colon !== -1 && !/\s/.test(head.slice(0, colon));
	const name = isLegacy ? head.slice(0, colon) : head.split(/\s+/)[0];
	const legacyTitle = isLegacy ? head.slice(colon + 1).trim() : "";
	if (legacyTitle && !attrs.title) attrs.title = legacyTitle;

	return { name: name || undefined, attrs };
};

export default parseDiagramInfo;
